import { Component, Input, OnInit } from '@angular/core';
// Service
import { BroadcastService } from '@cv-invision/core';
// Store
import { Store } from '@ngxs/store';
import { GenericIntegrationState } from '../state/generic-integation.state';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'cv-generic-header',
	templateUrl: './generic-header.component.html',
	styleUrls: ['./generic-header.component.scss'],
})
export class GenericHeaderComponent implements OnInit {
	integration$: Observable<any> = this.store.select(GenericIntegrationState.getIntegration);
	private atComponentDestroy: Subject<any> = new Subject<any>();
	@Input() data: any;

	public title: string;
	public showBackButton = false;
	public backUrl = '';
	public integrationName = '';

	constructor(
		private broadcast: BroadcastService,
		private store: Store,
	) {}

	ngOnInit(): void {
		if (this.data && this.data.title) {
			this.title = this.data.title;
		}

		if (this.data && this.data.backButton) {
			this.showBackButton = true;
			this.backUrl = this.data.backButton.url;
		}

		this.integration$.pipe(takeUntil(this.atComponentDestroy)).subscribe(integration => {
			this.integrationName = integration?.integrationName;
		});
	}

	/**
	 * return to the main intelligence module
	 */
	returnToMainModule(time: number): void {
		setTimeout(() => {
			this.broadcast.broadcast({
				name: 'GC_SUBHEADER_BACK',
				event: {}
			});
		}, time);
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next(true);
		this.atComponentDestroy.complete();
	}
}
